export enum RoutesEnum {
  TradeEntry = 'trade-entry',
  Results = 'results',
}
